import BestPriceDisplay from "./BestPriceDisplay";

export default BestPriceDisplay;